module.exports = __webpack_public_path__ + "img/development (3).7733459a.png";